import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { LandingComponent } from './components/landing/landing.component';
import { MarketplaceComponent } from './components/marketplace/marketplace.component';
import { SignInComponent } from './components/auth/sign-in/sign-in.component';
import { RegisterComponent } from './components/auth/register/register.component';
import { ForgotPasswordComponent } from './components/auth/forgot-password/forgot-password.component';
import { EmailVerificationComponent } from './components/auth/email-verification/email-verification.component';
import { StoreComponent } from './components/store/store.component';
import { WishlistComponent } from './components/wishlist/wishlist.component';
import { CheckoutComponent } from './components/checkout/checkout.component';
import { ProductDetailComponent } from './components/product-detail/product-detail.component';
import { PaymentCallbackComponent } from './components/payment-callback/payment-callback.component';
import { ShoppingCardSuccessComponent } from './components/shopping-card-success/shopping-card-success.component';
import { BillsPaymentComponent } from './components/bills-payment/bills-payment.component';
import { ProfileComponent } from './components/profile/profile';
import { OrdersComponent } from './components/orders/orders';
import { BillsTransactionsComponent } from './components/bills-transactions/bills-transactions';
import { AddCardComponent } from './components/add-card/add-card';
import { AddCardCallbackComponent } from './components/add-card-callback/add-card-callback';
import { CardsComponent } from './components/cards/cards';

export const routes: Routes = [
  {
    path: '',
    component: LandingComponent
  },
  {
    path: 'marketplace',
    component: MarketplaceComponent
  },
  {
    path: 'store/:id/:name',
    component: StoreComponent
  },
  {
    path: 'store/:id/:name/product/:productId',
    component: ProductDetailComponent
  },
  {
    path: 'store/:id/:name/payment-callback',
    component: PaymentCallbackComponent
  },
  {
    path: 'shopping-card-success',
    component: ShoppingCardSuccessComponent,
    canActivate: [authGuard]
  },
  {
    path: 'bills-payment/:id/:name',
    component: BillsPaymentComponent
  },
  {
    path: 'wishlist/:id',
    component: WishlistComponent,
    canActivate: [authGuard]
  },
  {
    path: 'checkout/:id',
    component: CheckoutComponent,
    canActivate: [authGuard]
  },
  {
    path: 'signin',
    component: SignInComponent
  },
  {
    path: 'register',
    component: RegisterComponent
  },
  {
    path: 'verify-email',
    component: EmailVerificationComponent
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [authGuard]
  },
  {
    path: 'orders',
    component: OrdersComponent,
    canActivate: [authGuard]
  },
  {
    path: 'orders/:id/:name',
    component: OrdersComponent,
    canActivate: [authGuard]
  },
  {
    path: 'bills-transactions',
    component: BillsTransactionsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'bills-transactions/:id/:name',
    component: BillsTransactionsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'add-card',
    component: AddCardComponent,
    canActivate: [authGuard]
  },
  {
    path: 'add-card-callback',
    component: AddCardCallbackComponent,
    canActivate: [authGuard]
  },
  {
    path: 'cards',
    component: CardsComponent,
    canActivate: [authGuard]
  }
];
